import { ReactNode } from "react";
import { AcceptedDocFormatsType } from "@/constants";
import { Jpg, Pdf } from "@/assets/icons/extensions";

export const getFileIcon = (extension: string | null): ReactNode => {
  switch (extension?.toLowerCase()) {
    case AcceptedDocFormatsType.Pdf:
      return <Pdf />;
    case AcceptedDocFormatsType.Jpg:
    case AcceptedDocFormatsType.Jpeg:
      return <Jpg />;
    default:
      return null;
  }
};
